export default __webpack_public_path__ + "static/media/7_fooddiary__february.12dadaac.jpg";